import React from 'react';
import { WorkflowCard } from './WorkflowCard';
import { WorkflowWithAgent } from '../hooks/useWorkflows';
import { trainingFlowsApi } from '../../agents/services/trainingFlowsApi';
import { toast } from '@/hooks/use-toast';

interface WorkflowListProps {
  workflows: WorkflowWithAgent[];
  onReload: () => void;
}

export const WorkflowList: React.FC<WorkflowListProps> = ({ workflows, onReload }) => {
  const handleDelete = async (id: string) => {
    if (!window.confirm('¿Estás seguro de que deseas eliminar este flow?')) {
      return;
    }

    try {
      await trainingFlowsApi.deleteFlowWithCascade(id);
      toast.success('Flow eliminado exitosamente');
      onReload();
    } catch (error) {
      console.error('Error deleting workflow:', error);
      toast.error('Error al eliminar el flow');
    }
  };

  if (workflows.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20">
        <div className="text-grey-400 text-center">
          <p className="text-lg font-medium mb-2">No hay flows creados</p>
          <p className="text-sm">Crea tu primer flow para comenzar</p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
      {workflows.map((workflow) => (
        <WorkflowCard
          key={workflow.id}
          workflow={workflow}
          onDelete={handleDelete}
        />
      ))}
    </div>
  );
};
